module.exports = __webpack_public_path__ + "66d80348c4126c5ab2f137202bb0d9b6.jpg";